
import React       from 'react';
import CSSModules  from 'react-css-modules';
import { connect } from 'react-redux';

import style from './style.scss';

import Button from '../Button';
import Input  from '../Input';

import * as eventListActions from '../../actions/publicEventList';

class EventSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            inputValue: null
        }
    }

    handleChange(e) {
        this.setState({inputValue: e.target.value});
    }

    _searchKeyPressed(event) {

        if (event.key === 'Enter') {

            this.props.onSearch(event.target.value);
        }
    }

    render() {

        return (
            <div>
                <label className={style['search-label']} htmlFor="search-input">Search</label>

                <div styleName="search-wrapper">

                    <div styleName="search-box-wrapper">

                        <Input
                            id="search-input"
                            onKeyPress={ this._searchKeyPressed.bind(this) }
                            className={style['search-box']}
                            value={this.state.inputValue}
                            onChange={this.handleChange.bind(this)}
                            blackColorPlaceholder={true}
                        />

                    </div>

                    <div styleName="search-button-wrapper">
                        <Button onClick={ this.props.onSearch.bind(this, this.state.inputValue) }>
                            <span className={style['search-button']}>Search</span>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return state.eventList;
}

export default connect(mapStateToProps)(CSSModules(EventSearch, style));


// WEBPACK FOOTER //
// ./components/EventSearch/index.js